const animationDuration = 600;

export function popupInit() {
  $(document).on('click', '.popup-open', (e) => {
    e.preventDefault();
    let target;
    const href = $(e.currentTarget).attr('href');
    if (!href) {
      target = $(e.currentTarget).data('popup');
    } else {
      target = href;
    }

    if (!target) return;

    const $popup = $(target);

    openPopup($popup);
  });

  $(document).on('click', '.popup-close', (e) => {
    e.preventDefault();
    closePopup($(e.currentTarget).parents('.popup'));
  });

  $(document).on('click', '.popup-close-button', (e) => {
    e.preventDefault();
    closePopup($(e.currentTarget).parents('.popup'));
  });

  $(document).on('click', '.popup', (e) => {
    if (
      !$(e.target).closest('.popup-container').length &&
      $(e.currentTarget).is(':not(.popup-hard-close)')
    ) {
      closePopup($(e.currentTarget));
    }
  });
}

/**
 *
 * @param {jQuery} $popup
 */
export function openPopup($popup) {
  $('body').addClass('overflow-hidden');
  $popup.addClass('popup-show');
}

/**
 *
 * @param {jQuery} $parent
 */
export function closePopup($parent) {
  $('body').removeClass('overflow-hidden');
  $parent.addClass('popup-hide');

  setTimeout(() => {
    $parent.removeClass('popup-show').removeClass('popup-hide');
  }, animationDuration);
}
